/*
| Payroll page: close-month confirm modal + overtime report modal (fetches the
| weekly segments above the fund and renders them per employee).
*/
import { screenSignal } from './screenScope';

const axios = (): any => (window as any).axios;
const esc = (v: unknown): string => String(v ?? '').replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string
));
const hours = (min: number): string => (min / 60).toLocaleString('cs-CZ', { maximumFractionDigits: 1 });

export function initPayroll(): void {
    const root = document.querySelector<HTMLElement>('[data-payroll]');
    if (!root) return;

    const toggle = (sel: string, show: boolean): void => {
        const el = document.querySelector<HTMLElement>(sel);
        if (el) el.hidden = !show;
    };

    // Close-month confirm modal.
    document.querySelector('[data-close-open]')?.addEventListener('click', () => toggle('[data-close-modal]', true));
    document.querySelector('[data-close-cancel]')?.addEventListener('click', () => toggle('[data-close-modal]', false));
    document.querySelector('[data-close-modal]')?.addEventListener('click', (e) => { if (e.target === e.currentTarget) toggle('[data-close-modal]', false); });

    // Reopen-month confirm modal (themed dialog instead of a native confirm).
    const reopenModal = document.querySelector<HTMLElement>('[data-reopen-modal]');
    document.querySelector('[data-reopen-open]')?.addEventListener('click', () => toggle('[data-reopen-modal]', true));
    document.querySelector('[data-reopen-cancel]')?.addEventListener('click', () => toggle('[data-reopen-modal]', false));
    reopenModal?.addEventListener('click', (e) => { if (e.target === reopenModal) toggle('[data-reopen-modal]', false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && reopenModal && !reopenModal.hidden) toggle('[data-reopen-modal]', false); }, { signal: screenSignal() });

    // Overtime report modal.
    const otModal = document.querySelector<HTMLElement>('[data-overtime-modal]');
    const otBody = document.querySelector<HTMLElement>('[data-overtime-body]');
    document.querySelector('[data-overtime-close]')?.addEventListener('click', () => toggle('[data-overtime-modal]', false));
    otModal?.addEventListener('click', (e) => { if (e.target === otModal) toggle('[data-overtime-modal]', false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && otModal && !otModal.hidden) toggle('[data-overtime-modal]', false); }, { signal: screenSignal() });

    document.querySelector('[data-overtime-open]')?.addEventListener('click', async () => {
        if (!otBody) return;
        otBody.innerHTML = '<div class="mz-note">…</div>';
        toggle('[data-overtime-modal]', true);
        const [year, month] = (root.dataset.month ?? '').split('-');
        try {
            const { data } = await axios().get(root.dataset.payroll, { params: { year, month } });
            otBody.innerHTML = renderOvertime(data);
        } catch {
            otBody.innerHTML = '<div class="mz-note">Chyba</div>';
        }
    });

    function renderOvertime(data: any): string {
        if (!data.rows.length) return `<div class="mz-note">Žádné přesčasy (fond ${esc(data.threshold_hours)} h/týden).</div>`;
        return data.rows.map((r: any) => {
            const segs = r.weeks.map((w: any) => `
                <li>
                    <span>${esc(w.label)}</span>
                    <span class="mz-dim">${hours(w.net_minutes)} h</span>
                    <span class="ot-h" style="color: var(--state-danger)">+${hours(w.overtime_minutes)} h</span>
                </li>`).join('');
            return `
                <div class="ot-week">
                    <div class="ot-week-head">
                        <strong>${esc(r.employee.name)}</strong>
                        <span style="color: var(--state-danger)">+${hours(r.total_overtime_minutes)} h celkem</span>
                    </div>
                    <ul class="ot-segs">${segs}</ul>
                </div>`;
        }).join('');
    }
}
